/** "$ 3.00" — prices always show cents, like in the design */
const formatUsd = (value: number): string => `$ ${value.toFixed(2)}`;

export { formatUsd };
